import { useEffect, useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface AffiliateInputProps {
  defaultValue: number
  onSave: (value: number) => Promise<void>
  isFetching: boolean
}

export const AffiliatePayoutInput = ({ defaultValue, onSave, isFetching }: AffiliateInputProps) => {
  const [value, setValue] = useState<number>(0)
  const { t } = useLocoTranslation()

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <div
      className={`focus-within:border-brand-primary main-transition-colors border-text-secondary/30 flex w-fit rounded-lg border ${
        isFetching && 'bg-skeleton-primary/40 animate-pulse'
      }`}
    >
      <input
        value={value}
        disabled={isFetching}
        type={'number'}
        onChange={e =>
          setValue(() => {
            const newValue = e.target.valueAsNumber
            if (newValue > 100) {
              return 100
            } else if (newValue < 0) {
              return 0
            }
            return newValue
          })
        }
        onBlur={() => onSave(value)}
        className={`main-transition-colors text-text-primary focus:border-brand-primary placeholder:text-text-tertiary/70 peer w-[66px] rounded-lg px-4 py-2.5 focus:outline-hidden`}
      />
      <div
        className={
          'bg-background-primary flex w-fit w-fit items-center justify-center rounded-r-lg px-4 py-2.5'
        }
      >
        {value > 1
          ? t('dashboard.name_of_times.days.plural')
          : t('dashboard.name_of_times.days.one')}
      </div>
    </div>
  )
}

export const AffiliateCommissionInput = ({
  defaultValue,
  onSave,
  isFetching,
}: AffiliateInputProps) => {
  const [value, setValue] = useState<number>(0)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <div
      className={`focus-within:border-brand-primary main-transition-colors border-text-secondary/30 flex w-fit rounded-lg border ${
        isFetching && 'bg-skeleton-primary/40 animate-pulse'
      }`}
    >
      <input
        value={value}
        disabled={isFetching}
        type={'number'}
        onChange={e =>
          setValue(() => {
            const newValue = e.target.valueAsNumber
            if (newValue > 100) {
              return 100
            } else if (newValue < 0) {
              return 0
            }
            return newValue
          })
        }
        onBlur={() => onSave(value)}
        className={`main-transition-colors text-text-primary focus:border-brand-primary placeholder:text-text-tertiary/70 peer w-[66px] rounded-lg px-4 py-2.5 focus:outline-hidden  `}
      />
      <div
        className={
          'bg-background-primary flex w-fit items-center justify-center rounded-r-lg px-4 py-2.5'
        }
      >
        %
      </div>
    </div>
  )
}
